<template>
  <div class="home-table">
    <empty-list-state
      v-if="showEmptyState"
      :is-multi-entity="fromAll"
      :type="type"
      :is-disabled="$permissions.isGuest"
    />
    <template v-else>
      <home-table-responsive
        v-if="$screen.isTabletOrMobile($mq)"
        v-bind="propsBinds"
      />
      <home-table-desktop
        v-else
        ref="homeTableDesktop"
        v-bind="propsBinds"
        @selected-rows="(val) => $emit('select-rows', val)"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { HomeTableProps } from '@/components/listing/home-table/home-table.constants'

/**
 * Component with table used both by mailboxes and projects home
 */
export default defineComponent({
  name: 'HomeTable',

  props: {
    ...HomeTableProps,
  },

  emits: ['select-rows'],

  computed: {
    showEmptyState(): boolean {
      return this.tableData.length === 0 && !this.isLoading
    },
    propsBinds(): any {
      return {
        type: this.type,
        tableData: this.tableData,
        isLoading: this.isLoading,
        fromAll: this.fromAll,
        fromEntityHome: this.fromEntityHome,
        customFields: this.customFields,
      }
    },
  },
  methods: {
    clearBulkEdit() {
      // @ts-ignore
      this.$refs.homeTableDesktop.clearBulkEdit()
    },
  },
})
</script>
